import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class config_marketplace_providers_template extends vnTemplate {

    protected globalCapTooltip: infoButton_template;
    protected geoRadiusTooltip: infoButton_template;
    protected geoRadiusMultiplierTooltip: infoButton_template;

    protected getMainElementType(): string {
        return "div";
    }

    protected getTemplateName(): string {
        return "config_marketplace_providers_template";
    }

    protected getTemplateHtml(): string {
        return /*html*/`
            <div class="w-form marketplace-config providers-config">
               <div class="form-header">
                  <input type="hidden">
                  <h3 class="form-title" data-bind="text: internalMode() ? 'Tiers' : 'Providers'"></h3>
               </div>

               <div class="form-body">
                   <h3 class="form-sub-title icon i-listing-2-preview" data-bind="text: internalMode() ? 'Tier Configuration' : 'Providers Configuration'"></h3>

                   <div class="form-group">
                       <label class="form-label" data-bind="text: internalMode() ? 'Configure tier traffic caps used by the automation script and geo radius limits on internal listings.' : 'Configure provider traffic caps used by the automation script and geo radius limit on provider listings.'"></label>
                   </div>

                   <div class="provider-tabs">
                       <ul class="provider-tab-headers" data-bind="foreach: configs">
                           <li class="provider-tab-header" data-bind="css: { active: $index() === $parent.activeTabIndex() }, event: { click: function(){ $parent.onSwitchTab($index()); } }">
                               <span data-bind="text: label"></span>
                               <button class="provider-tab-close icon i-delete"
                                       type="button"
                                       title="Delete this tab"
                                       data-bind="visible: !$parent.internalMode(), event: { click: function(){ $parent.onDeleteTab($index()); }, clickBubble: false }">
                                   <span class="hidden-text">Delete</span>
                               </button>
                           </li>
                       </ul>
                       <button class="btn border icon i-plus provider-tab-add" type="button" data-bind="visible: !internalMode(), event: { click: onAddTab }, enable: canAddTab">
                           <span>Add Tab</span>
                       </button>
                   </div>

                   <div class="mp-warning" data-bind="visible: configs().length === 0">
                       No provider tabs yet. Click "Add Tab" to configure a marketplace provider.
                   </div>

                   <!-- ko if: activeTabIndex() >= 0 && configs().length > 0 -->
                   <!-- ko with: configs()[activeTabIndex()] -->
                       <div class="form-group">
                           <label class="form-label" data-bind="text: $parent.internalMode() ? 'Tier' : 'Provider'"></label>
                           <select data-bind="options: $parent.getSelectableProvidersForColumn($data),
                                              optionsText: $parent.formatProviderName,
                                              value: configuredProvider,
                                              optionsCaption: $parent.internalMode() ? '-- Select tier --' : '-- Select provider --',
                                              enable: !providerLocked()"></select>
                       </div>

                       <div class="form-group">
                           <label class="form-label">Cap scope</label>
                           <select data-bind="value: capScope">
                               <option value="none">None</option>
                               <option value="per_provider" data-bind="text: $parent.internalMode() ? 'Capped by listing' : 'Capped by provider'"></option>
                               <option value="per_dealer">Capped by dealer</option>
                           </select>
                       </div>

                       <div class="form-group" data-bind="visible: capScope() !== 'none'">
                           <div class="multi-row">
                               <label class="form-label">Cap limit</label>
                               <div class="w-tooltips-adv pos-right short" data-bind="template: { name: 'infoButton-template', data: $parent.globalCapTooltip }"></div>
                           </div>
                           <input type="number" min="1" data-bind="value: capLimitValue">
                       </div>

                       <div class="form-group">
                           <div class="multi-row">
                               <label class="form-label">Geo Radius Limiting</label>
                               <div class="w-tooltips-adv pos-right short" data-bind="template: { name: 'infoButton-template', data: $parent.geoRadiusTooltip }"></div>
                           </div>
                           <select data-bind="value: geoRadiusLimiting">
                               <option value="none">None</option>
                               <option value="per_listing">Per Listing</option>
                               <option value="per_provider">Per Provider</option>
                           </select>
                       </div>

                       <div class="form-group" data-bind="visible: geoRadiusLimiting() === 'per_provider'">
                           <label class="form-label">Geo Radius Limit</label>
                           <input type="number" min="1" data-bind="value: geoRadiusLimitValue">
                       </div>

                       <div class="form-group" data-bind="visible: geoRadiusLimiting() === 'per_listing' || geoRadiusLimiting() === 'per_provider'">
                           <div class="multi-row">
                               <label class="form-label">Multiplier</label>
                               <div class="w-tooltips-adv pos-right short mp-multiplier-tooltip" data-bind="template: { name: 'infoButton-template', data: $parent.geoRadiusMultiplierTooltip }"></div>
                           </div>
                           <input type="number" min="0.01" step="0.01" data-bind="value: geoRadiusMultiplierValue">
                       </div>
                   <!-- /ko -->
                   <!-- /ko -->

               </div>

               <div class="form-footer">
                  <button data-bind="event: { click: onClickCancelProvidersSettings }" title="There will be no changes made" class="btn" type="button">Cancel</button>
                  <button data-bind="event: { click: onClickSaveProvidersSettings }, disable: !canSave()" class="btn highlight" type="button">Save</button>
               </div>
            </div>

            <style>
                .providers-config .provider-tabs {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 0.5rem;
                    border-bottom: 2px solid #eee;
                    margin-bottom: 1rem;
                    padding-bottom: 0.25rem;
                }
                .providers-config .provider-tab-headers {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                    gap: 0.25rem;
                    flex-wrap: wrap;
                    flex: 1 1 auto;
                }
                .providers-config .provider-tab-header {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    padding: 0.4rem 0.9rem;
                    border: 1px solid #ddd;
                    border-bottom: none;
                    border-radius: 4px 4px 0 0;
                    background-color: #f5f5f5;
                    cursor: pointer;
                    user-select: none;
                }
                .providers-config .provider-tab-header.active {
                    background-color: #fff;
                    font-weight: 700;
                    border-color: #bbb;
                    position: relative;
                    top: 2px;
                }
                .providers-config .provider-tab-close {
                    border: none;
                    background: transparent;
                    cursor: pointer;
                    padding: 0;
                    line-height: 1;
                    opacity: 0.5;
                }
                .providers-config .provider-tab-close:hover {
                    opacity: 1;
                    color: #c0392b;
                }
                .providers-config .provider-tab-add {
                    flex-shrink: 0;
                }
                .providers-config .form-group select,
                .providers-config .form-group input[type="number"] {
                    width: 100%;
                    max-width: 100%;
                    box-sizing: border-box;
                    padding: 0.25rem 0.4rem;
                    border: 1px solid #ccc;
                    border-radius: 3px;
                }
                .providers-config .mp-warning {
                    background-color: #fffbe6;
                    border: 1px solid #ffe58f;
                    border-radius: 4px;
                    color: #7d5a00;
                    font-size: 11px;
                    padding: 0.5rem 1.25rem;
                    margin: 1rem 0;
                }
                .providers-config .form-body {
                    overflow: visible;
                }
                .providers-config .form-group .w-tooltips-adv .tooltips-adv {
                    z-index: 2000;
                }
                .providers-config .form-group .multi-row {
                    margin-bottom: 0;
                }
                .providers-config .form-group .multi-row + input[type="number"] {
                    margin-top: 0.75rem;
                }
                .providers-config .form-group .multi-row + select {
                    margin-top: 0.75rem;
                }
                .providers-config .mp-multiplier-tooltip .tooltips-adv {
                    width: 220px;
                    min-width: 220px;
                    max-width: 220px;
                }
            </style>
        `;
    }

    protected initPartial(): void {
        this.globalCapTooltip = new infoButton_template('globalCapTooltip', this.getTemplateViewModel(), this.caller);
        this.globalCapTooltip.setTitle('Cap limit');
        this.globalCapTooltip.setContent(
            '<p>Daily click cap. Resets every day at midnight.</p>'
            + '<p><strong>Per provider</strong> applies to the provider total. '
            + '<strong>Per dealer</strong> applies to each dealer separately.</p>'
        );

        this.geoRadiusTooltip = new infoButton_template('geoRadiusTooltip', this.getTemplateViewModel(), this.caller);
        this.geoRadiusTooltip.setTitle('Geo Radius Limiting');
        this.geoRadiusTooltip.setContent(
            '<p>Enforces a strict distance limit on the listings and the user&apos;s real location.</p>'
            + '<p><strong>Per provider</strong>: Flat radius for all its listings.</p>'
            + '<p><strong>Per listing</strong>: Each listing has its own range. Must be set by the provider and read on ingestion.</p>'
        );

        this.geoRadiusMultiplierTooltip = new infoButton_template('geoRadiusMultiplierTooltip', this.getTemplateViewModel(), this.caller);
        this.geoRadiusMultiplierTooltip.setTitle('Multiplier');
        this.geoRadiusMultiplierTooltip.setContent(
            '<p>Multiplier of the range distance.</p>'
            + '<p>Example: The provider may define an extended range on their default radius.</p>'
            + '<p>Default is 1.</p>'
        );
    }

    /**
     * Refresh the registered knockout template markup when this module reloads.
     */
    public includeTemplate(): void {
        const existing = document.getElementById(this.getTemplateName());
        if (existing) {
            existing.innerHTML = this.getTemplateHtml();
            return;
        }

        const head = document.getElementsByTagName('head');
        head[0].appendChild(this.template);
    }

    /**
     * Provider options available for a specific tab, always including that tab's
     * currently assigned provider so locked tabs keep a valid select value.
     */
    public getSelectableProvidersForColumn(col: any): string[] {
        const vm = this.getTemplateViewModel();
        const assignedProvider = this.getProviderSlugForColumn(col);
        const usedProviders = vm.configs()
            .filter((configCol) => configCol !== col)
            .map((configCol) => this.getProviderSlugForColumn(configCol))
            .filter(Boolean);

        const options = vm.providers().filter((provider) => usedProviders.indexOf(provider) === -1);

        if (assignedProvider && options.indexOf(assignedProvider) === -1) {
            options.unshift(assignedProvider);
        }

        return options;
    }

    private buildColumnViewModel(configKey: string): any {
        const col: any = {
            key: configKey,
            label: ko.observable(this.labelFromKey(configKey)),
            configuredProvider: ko.observable(null),
            providerLocked: ko.observable(false),
            capScope: ko.observable('none'),
            capLimitValue: ko.observable(''),
            geoRadiusLimiting: ko.observable('none'),
            geoRadiusLimitValue: ko.observable(''),
            geoRadiusMultiplierValue: ko.observable('1'),
        };

        col.configuredProvider.subscribe((slug: string | null) => {
            if (!slug || !this.isDraftTabKey(col.key)) {
                return;
            }
            col.key = slug;
        });

        col.capScope.subscribe((capScope: string) => {
            if (capScope === 'none') {
                col.capLimitValue('');
            }
        });

        return col;
    }

    private isDraftTabKey(key: string): boolean {
        return /^providerConfig\d+$/.test(key);
    }

    /**
     * Resolve the provider slug assigned to a tab. Uses the tab key when it is
     * already a saved provider slug, so used providers stay reserved after tab switches.
     */
    public getProviderSlugForColumn(col: any): string | null {
        const configured = col.configuredProvider();
        if (configured) {
            return configured;
        }

        if (col.key && !this.isDraftTabKey(col.key)) {
            return col.key;
        }

        return null;
    }

    private labelFromKey(key: string): string {
        const match = /^providerConfig(\d+)$/.exec(key);
        return match ? ("Provider Config " + match[1]) : this.capitalizeProvider(key);
    }

    /**
     * Capitalize the first letter of a provider slug for tab display only.
     * The underlying slug (key/configuredProvider) stays lowercase for saving.
     */
    private capitalizeProvider(slug: string): string {
        if (!slug) {
            return slug;
        }
        return slug.charAt(0).toUpperCase() + slug.slice(1);
    }

    private numberFromKey(key: string): number {
        const match = /^providerConfig(\d+)$/.exec(key);
        return match ? parseInt(match[1], 10) : 0;
    }

    private applyProviderSettings(col: any, providerCap: any) {
        const capLimit = providerCap && providerCap.cap_limit != null
            ? providerCap.cap_limit
            : null;
        const geoRadiusLimiting = providerCap && providerCap.geo_radius_limiting
            ? providerCap.geo_radius_limiting
            : 'none';
        const geoRadiusLimit = providerCap && providerCap.geo_radius_limit != null
            ? providerCap.geo_radius_limit
            : null;
        const geoRadiusMultiplier = providerCap && providerCap.geo_radius_multiplier != null
            ? providerCap.geo_radius_multiplier
            : null;

        col.capScope(this.normalizeCapScope(providerCap && providerCap.cap_type));
        col.capLimitValue(capLimit != null && capLimit !== '' ? String(capLimit) : '');
        col.geoRadiusLimiting(
            geoRadiusLimiting === 'per_listing' || geoRadiusLimiting === 'per_provider'
                ? geoRadiusLimiting
                : 'none'
        );
        col.geoRadiusLimitValue(geoRadiusLimit != null && geoRadiusLimit !== '' ? String(geoRadiusLimit) : '');
        col.geoRadiusMultiplierValue(
            geoRadiusMultiplier != null && geoRadiusMultiplier !== ''
                ? String(geoRadiusMultiplier)
                : '1'
        );
    }

    /**
     * Pick which tab should be active after deleting tab at deleteIndex.
     */
    private nextActiveTabIndex(activeIndex: number, deleteIndex: number, newLength: number): number {
        if (newLength === 0) {
            return -1;
        }

        if (deleteIndex < activeIndex) {
            return activeIndex - 1;
        }

        if (deleteIndex > activeIndex) {
            return activeIndex;
        }

        return Math.max(0, Math.min(deleteIndex, newLength - 1));
    }

    protected buildViewModel(): any {
        const self = this;

        const vm: any = {
            internalMode: ko.observable(false),
            providers: ko.observableArray([]),
            configs: ko.observableArray([]),
            activeTabIndex: ko.observable(-1),

            getSelectableProvidersForColumn: (col) => {
                return self.getSelectableProvidersForColumn(col);
            },

            formatProviderName: (provider: string) => {
                return vm.internalMode() ? self.capitalizeProvider(provider) : provider;
            },

            onSwitchTab: (index) => {
                if (index >= 0 && index < vm.configs().length) {
                    vm.activeTabIndex(index);
                }
            },

            onAddTab: () => {
                const existing = vm.configs();
                const maxN = existing.reduce((m, c) => Math.max(m, self.numberFromKey(c.key)), 0);
                const newKey = "providerConfig" + (maxN + 1);
                const newCol = self.buildColumnViewModel(newKey);
                vm.configs.push(newCol);
                vm.activeTabIndex(vm.configs().length - 1);
            },

            onDeleteTab: (deleteIndex) => {
                const list = vm.configs();
                if (deleteIndex < 0 || deleteIndex >= list.length) {
                    return;
                }

                const activeIndex = vm.activeTabIndex();
                const newConfigs = list.filter((_, index) => index !== deleteIndex);
                const newActiveIndex = self.nextActiveTabIndex(activeIndex, deleteIndex, newConfigs.length);

                vm.activeTabIndex(-1);
                vm.configs(newConfigs);
                vm.activeTabIndex(newActiveIndex);
            },

            onClickCancelProvidersSettings: () => {
                self.caller.cancelProvidersSettings();
            },

            onClickSaveProvidersSettings: () => {
                self.caller.saveProvidersSettings();
            },
        };

        vm.canAddTab = ko.computed(() => {
            return !vm.internalMode() && vm.configs().length < vm.providers().length;
        });

        vm.canSave = ko.computed(() => {
            if (vm.configs().length === 0) {
                return true;
            }

            return vm.configs().every(col => {
                if (!self.getProviderSlugForColumn(col)) {
                    return false;
                }

                const capScope = this.normalizeCapScope(col.capScope());
                const geoRadiusLimiting = col.geoRadiusLimiting();
                if (capScope !== 'none') {
                    const cap = parseInt(ko.unwrap(col.capLimitValue), 10);
                    if (isNaN(cap) || cap < 1) {
                        return false;
                    }
                }

                if (geoRadiusLimiting === 'none') {
                    return true;
                }

                if (geoRadiusLimiting !== 'per_listing' && geoRadiusLimiting !== 'per_provider') {
                    return false;
                }

                const multiplier = parseFloat(ko.unwrap(col.geoRadiusMultiplierValue));
                if (isNaN(multiplier) || multiplier <= 0) {
                    return false;
                }

                if (geoRadiusLimiting === 'per_listing') {
                    return true;
                }

                const radiusLimit = parseInt(ko.unwrap(col.geoRadiusLimitValue), 10);
                return !isNaN(radiusLimit) && radiusLimit > 0;
            });
        });

        return vm;
    }

    public setProvidersSettings(providers: string[], providerCaps: any) {
        const vm = this.getTemplateViewModel();
        const defaultProviders = ['lotlinx', 'carzing', 'carsAndBids'];
        const list = (Array.isArray(providers) && providers.length > 0) ? providers : defaultProviders;
        vm.providers(list);

        const capsObj = (providerCaps && typeof providerCaps === 'object') ? providerCaps : {};
        const providerKeys = vm.internalMode()
            ? list.slice()
            : Object.keys(capsObj).sort();

        const cols = providerKeys.map(providerKey => {
            const col = this.buildColumnViewModel(providerKey);
            col.configuredProvider(providerKey);
            col.label(this.capitalizeProvider(providerKey));
            col.providerLocked(true);
            this.applyProviderSettings(col, capsObj[providerKey]);
            return col;
        });

        vm.activeTabIndex(-1);
        vm.configs(cols);
        vm.activeTabIndex(cols.length > 0 ? 0 : -1);
    }

    private serializeColumn(col: any): any {
        const capScope = this.normalizeCapScope(col.capScope());
        const parsedCap = capScope === 'none' ? null : parseInt(ko.unwrap(col.capLimitValue), 10);
        if (capScope !== 'none' && (isNaN(parsedCap) || parsedCap < 1)) {
            return null;
        }

        const geoRadiusLimiting = this.normalizeGeoRadiusLimiting(col.geoRadiusLimiting());
        const serialized: any = {
            cap_type: capScope,
            cap_limit: parsedCap,
            geo_radius_limiting: geoRadiusLimiting,
        };

        if (geoRadiusLimiting === 'per_provider') {
            serialized.geo_radius_limit = parseInt(ko.unwrap(col.geoRadiusLimitValue), 10);
        }

        if (geoRadiusLimiting === 'per_listing' || geoRadiusLimiting === 'per_provider') {
            serialized.geo_radius_multiplier = parseFloat(ko.unwrap(col.geoRadiusMultiplierValue));
        }

        return serialized;
    }

    /**
     * Preserve an explicit uncapped provider scope while defaulting unknown values to provider-level caps.
     */
    private normalizeCapScope(value: string): string {
        if (value === 'none' || value === 'per_dealer' || value === 'per_provider') {
            return value;
        }

        return 'per_provider';
    }

    /**
     * Keep unknown or legacy radius values from being saved back as active limiting modes.
     */
    private normalizeGeoRadiusLimiting(value: string): string {
        return value === 'per_listing' || value === 'per_provider' ? value : 'none';
    }

    public getProvidersSettings() {
        const vm = this.getTemplateViewModel();
        const out: any = {};

        vm.configs().forEach((col) => {
            const provider = this.getProviderSlugForColumn(col);
            if (!provider) {
                return;
            }

            const serialized = this.serializeColumn(col);
            if (serialized) {
                out[provider] = serialized;
            }
        });

        return { provider_caps: out };
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/config_marketplace_providers_template.ts